<template>
  <div role="alert" v-if="errors.length" class="alert alert-danger" id="error-list" aria-live="polite">
    <h4>
      <span class="container">
        <img src="../assets/circle.png" class="error-icon" alt />
        {{ $t('errorSummary', { errCount: errors.length }) }}
      </span>
    </h4>
    <ul class="container">
      <li v-for="error in errors" :key="error.key" v-html="error.value"></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "staticErrorList",
  props: ["errors"],
  components: {},
  data() {
    return {};
  }
};
</script>